import { render, staticRenderFns } from "./LmFooter.vue?vue&type=template&id=38e5a5d9&scoped=true"
import script from "./LmFooter.vue?vue&type=script&lang=js"
export * from "./LmFooter.vue?vue&type=script&lang=js"
import style0 from "./LmFooter.vue?vue&type=style&index=0&id=38e5a5d9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e5a5d9",
  null
  
)

export default component.exports